import { Box } from '@cp/ds/src/components/box';
import { Breadcrumbs } from '@cp/ds/src/components/breadcrumbs';
import { Container } from '@cp/ds/src/components/container';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { Helmet } from 'react-helmet';
import { RouteConfigComponentProps } from 'react-router-config';
import Header from 'src/widgets/header';
import { RoutedLink } from 'src/shared/ui/link';
import { TeamView } from './view';

const TeamPage: React.FC<RouteConfigComponentProps> = () => {
  return (
    <Box>
      <Helmet>
        <title>Сотрудники Юхелп в России - YouHelp</title>
        <meta
          content="Биографии сотрудников YouHelp, включая должности и опыт. Узнайте больше о команде разработчиков Youhelp."
          name="description"
        />
      </Helmet>

      <Header />

      <Container>
        <Breadcrumbs
          LinkComponent={RoutedLink}
          items={[
            {
              path: '/',
              label: 'Главная',
            },
            {
              path: '',
              label: 'Команда',
            },
          ]}
          sx={{ my: 2 }}
        />
        <Typography component="h2" sx={{ typography: { xs: 'h4', md: 'h2' }, m: 0, mb: 2.75 }}>
          Команда
        </Typography>
        <TeamView />
      </Container>
    </Box>
  );
};

export default TeamPage;
